import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import { sendInvite } from "../../api/invites";

function InviteDialog({ open, onClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  async function handleSend() {
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      await sendInvite({
        email: email.trim(),
        message: message.trim(),
      });
      setSuccessMessage("Invite sent.");
      setEmail("");
      setMessage("");
    } catch (error) {
      setErrorMessage(error.message || "Unable to send invite.");
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    if (loading) return;
    setErrorMessage("");
    setSuccessMessage("");
    onClose?.();
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Invite someone</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Invite someone you trust to join TrustBud.
          </Typography>
          <TextField
            label="Email address"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            fullWidth
            required
          />
          <TextField
            label="Personal message (optional)"
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            fullWidth
            multiline
            minRows={3}
            helperText="Keep it short and personal."
          />
          {errorMessage && (
            <Typography variant="body2" color="error">
              {errorMessage}
            </Typography>
          )}
          {successMessage && (
            <Typography variant="body2" color="success.main">
              {successMessage}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Close
        </Button>
        <Button
          variant="contained"
          onClick={handleSend}
          disabled={loading || !email.trim()}
        >
          {loading ? "Sending..." : "Send invite"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InviteDialog;
